import { Dispatch, SetStateAction, createContext, useContext } from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { FormStage } from './CreateUserModal';
import { IFormInput } from './types';

interface FormConTextValue {
  form: IFormInput;
  inputHandler: (key: string, value: string | boolean) => void;
  register: UseFormRegister<IFormInput>;
  errors: FieldErrors<IFormInput>;
  formDetails: any;
  currentStage: FormStage;
  handleStageChange: (e: any, direction?: 'next' | 'previous') => void;
  setCoordinates: Dispatch<
    SetStateAction<{
      lat: number;
      long: number;
    }>
  >;
}

export const FormContext = createContext<FormConTextValue | null>(null);
export const useFormContext = () => {
  const context = useContext(FormContext);
  if (context === null) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};
